import React, { Fragment } from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import CardItem from "./CardItem";
import RolesService from "../../../../services/AdminManagment/RolesService";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { useNavigate } from "react-router-dom";

const Roles = () => {
	const [data, setData] = useState([]);
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(null);
	const [search, setSearch] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const Auth = useSelector((state) => state.auth?.auth);
	const navigate = useNavigate();
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const rolesService = new RolesService();

	return (
		<Fragment>
			<Card className="mb-3">
				<Card.Body className="d-flex justify-content-between p-3 align-items-center">
					<div className="input-group w-50">
						<input
							type="text"
							style={{
								borderRadius: "8px",
								color: "initial",
								padding: "18px 16px",
							}}
							className="form-control"
							placeholder={`${Translate[lang]?.search_by} I.D, ${Translate[lang]?.name}`}
							value={search}
							onChange={(e) => setSearch(e.target.value)}
						/>
						<div
							className="flaticon-381-search-2"
							style={{
								position: "absolute",
								zIndex: "1",
								right: lang === "en" && "16px",
								left: lang === "ar" && "16px",
								top: "50%",
								transform: "translate(0, -50%)",
							}}></div>
					</div>
					<div>
						{/* {isExist("add_employees") && ( */}
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => {
								setItem({});
								navigate("/roles/add-role");
							}}>
							<i className="la la-plus mx-1"></i>
							{Translate[lang]?.add} {Translate[lang]?.role}
						</Button>
						{/* )} */}
					</div>
				</Card.Body>
			</Card>

			<Row>
				<Col lg={12}>
					<Card>
						<Card.Body className={`${hasData === 0 && "text-center"} `}>
							{loading && (
								<div style={{ height: "300px" }}>
									<Loader />
								</div>
							)}
							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>{Translate[lang]?.name}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.admins_count}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.actions}</strong>
											</th>
										</tr>
									</thead>

									<tbody className="table-body">
										{data?.map((item, index) => {
											return (
												<CardItem
													index={index}
													key={index}
													item={item}
													setItem={setItem}
													setShouldUpdate={setShouldUpdate}
												/>
											);
										})}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={rolesService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={search}
							/>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Fragment>
	);
};

export default Roles;
